// builder-components.ts
import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { TYP_RECOMMENDATION_CARD_SLOT_KEYS } from './constants';

const TypRecommendationCards = dynamic(
  () => import('./typ-recommendation-cards'),
);
const TypRecommendationSectionWrapper = dynamic(
  () => import('./typ-recommendation-section-wrapper'),
);
const TypRecommendationSectionWrapperWithChildren = withChildren(
  TypRecommendationSectionWrapper,
);

Builder.registerComponent(TypRecommendationCards, {
  name: 'TypRecommendationCards',
  noWrap: true,
});

Builder.registerComponent(TypRecommendationSectionWrapperWithChildren, {
  name: 'TypRecommendationSectionWrapper',
  noWrap: true,
  canHaveChildren: true,
  inputs: [
    {
      name: 'slot',
      type: 'string',
      friendlyName: 'Slot',
      enum: [...TYP_RECOMMENDATION_CARD_SLOT_KEYS],
    },
    {
      name: 'toggle',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Force Show In Visual Editor',
      helperText:
        'Only forces this section to render while editing in Builder visual editor.',
    },
  ],
});
